import Request from'./request';

export default class TestRunnerService {

	static instance() {
		if (this._instance) {
			return this._instance;
		}
		return (this._instance = new TestRunnerService());
	}

	listAllTests() {
		return Request.instance().get('/console/v1/tests/list');
	}

	runTests(testRun) {
		return Request.instance().post('/console/v1/tests/run', testRun);
	}

	cancelTest(id) {
		return Request.instance().put('/console/v1/tests/cancel', { id } );
	}

	getLastRunning() {
		return Request.instance().get('/console/v1/tests/run/current');
	}

	getTestRunByRunId(runId) {
		return Request.instance().get('/console/v1/tests/run/get/' + runId );
	}

	filterTestRuns(fromDate, toDate) {
		return Request.instance().post('/console/v1/tests/run/filter', { fromDate, toDate } );
	}

	cancelTestRun(id) {
		return Request.instance().put('/console/v1/tests/run/cancel/' + id );
	}

	getLatestRun() {
		return Request.instance().get('/console/v1/tests/run/latest');
	}
}
